import styled from 'styled-components'
import { Box } from '@ally/metronome-ui'
import { AccountDetailsLink } from '../Shared'

export const StyledAccountDetailsLink = styled(AccountDetailsLink)`
  ${({ theme: { space } }): string => `
  width: 100%;
  justify-content: flex-start;

  &:first-child {
    border-radius: ${space.xxs} ${space.xxs} 0 0;
  }
`};
`

export const TotalBalanceContainer = styled(Box)`
  ${({ theme: { space, colors } }): string => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-left-style: solid;
  border-left-width: 7px;
  padding: ${space.sm} ${space.xs} ${space.sm} ${space.xs};
  border-top: 1px solid ${colors['slate-2']};
  width: 100%;
  border-bottom: 1px solid ${colors['slate-2']};
  border-radius: 0 0 4px 4px;
`};
`
